<template>
    <div class="profile__detail">
        
        <!-- SUCHE -->
        <div class="faq-search">
            <input v-model="searchWord" type="text" placeholder="Was möchtest du wissen?">
        </div>

        <!-- FRAGEN -->
        <div class="list">
            <router-link v-for="q in filteredQuestions" :key="q.id" :to="'/support/faq-detail/' + q.id" class="list__item drilldown">
                <div class="list__item__content">
                    <div class="list__item__label">
                        {{ q.question }}
                    </div>
                </div>
            </router-link>
        </div>
        
    </div>
</template>
<script>
import axios from 'axios';
import firebase from 'firebase';

export default {
    name: 'SupportFAQ',
    data() {
        return {
            user: null,
            questions: [],
            searchWord: "",
        }
    },
    methods: {
        init(){
            this.user = firebase.auth().currentUser;
            let category = this.$route.params.category;
            let apiUrl = this.$store.getters.getApiUrl;
                axios
                .get(apiUrl + 'faq/?fields=_,id,question,published,category')
                .then(response => {
                    this.questions = response.data.items.filter(q => q.published && q.category == category);
                });
        },
    },
    mounted() {
        this.init();
    },
    computed: {
        filteredQuestions() {
            let s = this.searchWord;
            if (s == null || s == "") return this.questions;
            return this.questions.filter( f => f.question.search(new RegExp(s, "i")) >= 0);
        }
    }
}
</script>

<style lang="scss">
    .faq-search {
        position: relative;
        margin: -6px 0 16px;

        &:before {
            content: '';
            position: absolute;
            top: 14px;
            left: 14px;
            width: 16px;
            height: 16px;
            background: url('../assets/ic_16_search.svg');
            opacity: .32;
        }

        input {
            padding: 10px 16px 10px 40px !important;
            font-size: 14px;
            text-align: left;
            font-weight: 600;
        }
    }
</style>